
/* ============================== src/utils/chatKey.js ============================== */
// src/utils/chatKey.js
/**
 * Ключ чата и набор ключей для отметок «прочитано до» / подсчёта
 * непрочитанных. Семантика совпадает с backend/src/domain/chat-key.ts:
 *   { taskId }              → [`task:<taskId>`]
 *   { projectId }           → [`project:<projectId>`]
 *   { projectId, taskId }   → [`task:<taskId>`, `project:<projectId>`]
 *
 * Раньше chatKeysFor при наличии taskId безусловно добавлял
 * `project:${projectId}` — при projectId === undefined получался мусорный
 * ключ «project:undefined». Сейчас проект добавляется только при
 * наличии. В текущем коде разница не проявлялась: комментарии в БД
 * всегда имеют project_id (NOT NULL), а useMarkChatReadMutation шлёт
 * сырое тело в POST /chat-reads (chatKeysFor фронт там не участвует).
 * Фикс превентивный: защищает от «project:undefined» при будущих
 * вызовах chatKeysFor({ taskId }) и приводит поведение к бэкенду.
 *
 * chatKey (единичный) возвращает null вместо мусорной строки, если
 * не задан ни taskId, ни projectId — на фронте бросать в render опасно
 * (красный экран); caller обязан проверить null. Бэк (chat-key.ts)
 * в этом случае бросает.
 */

export const chatKey = ({ projectId, taskId }) => {
  if (taskId) return `task:${taskId}`;
  if (projectId) return `project:${projectId}`;
  return null;
};

export const chatKeysFor = ({ projectId, taskId }) => {
  const keys = [];
  if (taskId) keys.push(`task:${taskId}`);
  if (projectId) keys.push(`project:${projectId}`);
  return keys;
};
